import { createContext, type ReactNode, useContext, useMemo } from 'react';

import { type CardPhrases, cardPhrasesFor } from './order-card-phrases';

const CardPhrasesContext = createContext<CardPhrases>(cardPhrasesFor('sv'));

export function CardLanguageProvider({
  language,
  children,
}: {
  language: string;
  children: ReactNode;
}) {
  const phrases = useMemo(() => cardPhrasesFor(language), [language]);
  return <CardPhrasesContext.Provider value={phrases}>{children}</CardPhrasesContext.Provider>;
}

export function useCardPhrases(): CardPhrases {
  return useContext(CardPhrasesContext);
}
